{ avatarDomain } = require '@trello/config'
t = require('app/scripts/views/internal/teacup-with-helpers')('member')

module.exports = t.renderable ({ avatarHash, viewTitle, initials, isDeactivated, isBoardAdmin, isOrganizationAdmin }) ->
  title = viewTitle
  if avatarHash
    avatarUrl = [avatarDomain, avatarHash, '30.png'].join('/')
    avatarUrl2x = [avatarDomain, avatarHash, '50.png'].join('/')
    t.img {
      class: 'member-avatar'
      height: '30'
      width: '30'
      src: avatarUrl
      srcset: "#{avatarUrl} 1x, #{avatarUrl2x} 2x"
      alt: title
      title
    }

  else
    t.span '.member-initials', { title, 'aria-label': title }, ->
      t.text initials

  if !isDeactivated
    if isBoardAdmin
      t.span '.member-type.admin', { title: t.l('this-member-is-an-admin-of-this-board') }
    if isOrganizationAdmin
      t.span '.member-type.admin', { title: t.l('this-member-is-an-admin-of-this-organization') }

  t.span '.member-gold-badge', { title: t.l('this-member-has-trello-gold') }
